import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SeparatorComponent } from '@interacta-shared/ui';

@Component({
    selector: 'interacta-user-menu-separator',
    template: `<interacta-separator
        class="my-16 block"
        [height]="'large'"
        [thickness]="'soft'"
    />`,
    imports: [SeparatorComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuSeparatorComponent {}
